// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"230":"confirmation","231":"checkout","690":"items","697":"donate"}[chunkId] || chunkId) + "." + {"230":"1d20ccdb","231":"bddfb7f5","338":"5a90bb06","690":"d791bb38","697":"487d5288"}[chunkId] + ".js";
};